import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Reports are expensive to compute and change slowly.
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      retry: (count, err) => err?.retryable === true && count < 1,
    },
  },
});
